import { Card, Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataEfluente from "./dataEfluente";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const Efluentes = ({ listadoEfluentes }) => {
  const { columns, getRows } = dataEfluente;

  const memoizedRows = useMemo(() => {
    if (listadoEfluentes) {
      const listadoSinBorrar = listadoEfluentes.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoEfluentes]);
  // Render del menú contextual

  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Efluentes Gaseosos
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoEfluentes?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(Efluentes);

Efluentes.propTypes = {
  listadoEfluentes: PropTypes.array.isRequired,
};
